import * as React from 'react'

import { Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  paid: boolean
}

const BreakTag = ({ paid }: Props) => {
  const breakTagConfig = {
    true: {
      color: Tag.Types.lime,
      text: i18n.t('time_tracking.settings.custom_breaks.paid_break'),
    },
    false: {
      color: Tag.Types.malibu,
      text: i18n.t('time_tracking.settings.custom_breaks.unpaid_break'),
    },
  }

  const { color, text } = breakTagConfig[`${paid}`]

  return <Tag type={color}>{text}</Tag>
}

export default BreakTag
